import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './WixDatePicker.css';

export const DATE_FORMAT = 'YYYY-MM-DD';

class WixDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
  }

  open(ev) {
    const calendarEl = this.container.querySelector('.WixDatePicker__Calendar');

    if (!(calendarEl && calendarEl.contains(ev.target))) {
      this.el.setOpen(true);
    }
  }

  render() {
    const { selected, onChange, label, ...otherProps } = this.props;

    return (
      <div className="DatePicker_PseudoSelect">
        <div className="dropdown select" tabindex="0">
          <label>{label}</label>
          <div className="dd">
            <div className="selected-container">
              <div className="selected">{selected}</div>
            </div>
            <i className="expand arrow">
              <svg
                className="symbol-arrowDown"
                width="12"
                height="12"
                viewBox="135.1 -517.4 1024 1024"
              >
                <path
                  d="M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z"
                  className="c1"
                />
              </svg>
            </i>
          </div>
        </div>
        <div
          className="DatePickerWrapper"
          ref={el => {
            this.container = el;
          }}
          onClick={this.open}
        >
          <DatePicker
            {...otherProps}
            ref={el => {
              this.el = el;
            }}
            selected={moment(selected, DATE_FORMAT)}
            onChange={newVal => {
              if (onChange) {
                onChange(newVal.format(DATE_FORMAT));
              }
            }}
            dateFormat={DATE_FORMAT}
            className="WixDatePicker"
            calendarClassName="WixDatePicker__Calendar"
          />
        </div>

      </div>
    );
  }
}

export default WixDatePicker;



// WEBPACK FOOTER //
// ./src/commons/components/WixDatePicker.jsx